import { Controller } from "@hotwired/stimulus"
import { configureListingTrix } from "../listing_trix_config"

export default class extends Controller {
  static targets = ["editor", "input"]

  connect() {
    configureListingTrix()
    this.editorTarget.addEventListener("trix-initialize", this.onInitialize)
    this.editorTarget.addEventListener("trix-file-accept", this.blockAttachment)
  }

  disconnect() {
    this.editorTarget.removeEventListener("trix-initialize", this.onInitialize)
    this.editorTarget.removeEventListener("trix-file-accept", this.blockAttachment)
  }

  onInitialize = (event) => {
    if (event.target !== this.editorTarget) return

    const html = this.inputTarget.value?.trim()
    if (!html) return
    if (!this.editorTarget.editor?.isEmpty?.()) return

    this.editorTarget.editor.loadHTML(html)
  }

  blockAttachment = (event) => {
    event.preventDefault()
  }
}
